import React from 'react';
import { buildDiscordConnectUrl } from '../../utils/authUrls';
import {
  DISCORD_CONNECTED_LABEL,
  DISCORD_PREP_CONNECT_MESSAGE,
  DISCORD_READY_MATCHING_MESSAGE,
} from '../discordIdentity';

interface JoinDiscordPromptProps {
  connected: boolean;
  returnTo: string;
  variant: 'action' | 'prep';
}

const JoinDiscordPrompt: React.FC<JoinDiscordPromptProps> = ({
  connected,
  returnTo,
  variant,
}) => {
  if (connected) {
    return (
      <div className="space-y-1" data-testid="join-discord-connected-status">
        <p
          className="text-sm text-emerald-200 font-medium"
          data-testid="join-discord-connected-badge"
        >
          {DISCORD_CONNECTED_LABEL}
        </p>
        <p className="text-sm text-secondary-400" data-testid="join-discord-ready-message">
          {DISCORD_READY_MATCHING_MESSAGE}
        </p>
      </div>
    );
  }

  if (variant === 'prep') {
    return (
      <a
        href={buildDiscordConnectUrl(returnTo)}
        className="text-sm text-secondary-400 hover:text-white block"
        data-testid="invite-prep-discord-link"
      >
        {DISCORD_PREP_CONNECT_MESSAGE}
      </a>
    );
  }

  return (
    <a
      href={buildDiscordConnectUrl(returnTo)}
      className="btn-secondary inline-block"
      data-testid="invite-connect-discord-link"
    >
      Connect Discord
    </a>
  );
};

export default JoinDiscordPrompt;
